export default __webpack_public_path__ + "static/media/95.c7d00552.jpg";